// import { createStore } from 'redux'

// const initialState = {
//   sidebarShow: true,
// }

// const changeState = (state = initialState, { type, ...rest }) => {
//   switch (type) {
//     case 'set':
//       return { ...state, ...rest }
//     default:
//       return state
//   }
// }

// const store = createStore(changeState)
// export default store

const dateOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
};

const timeOptions = {
    timeZone: 'UTC',
    hour: 'numeric',
    minute: 'numeric',
};

export const formatUTC = (strDate, time) => {
    const date = new Date(strDate);
    const datetoUTC = date.toLocaleDateString('uk-UA', dateOptions);
    const timetoUTC = date.toLocaleTimeString('uk-UA', timeOptions);
    // console.log(time);
    if (time) {
        return `${datetoUTC} ${timetoUTC}`;
    }
    else {
        return `${datetoUTC}`;
    }
}


export function getAttributeBySlug(arr, slug, lang = 'en') {
  const rez = arr.find(attribute => {
    return (attribute.slug === slug);
  })

  return (
    rez
      ? { ...rez, attributeItems: rez?.attributeItems?.filter((attr) => attr?.language?.key === lang) }
      : undefined
  );
}
  
export function getAttributeById(obj, id) {
    return obj?.attributeItems?.find(attribute => {
      return (attribute.id === id);
    })
}

// Витягуємо контент до першої крапки, видаляємо HTML-теги та HTML-ентіті
export const getDescription = (content) => {
    // if (!content) return "Опис публікації";
    if (!content) return ``;
    const textContent = content
      .replace(/<[^>]+>/g, '') // Видаляємо HTML-теги
      .replace(/&nbsp;|&amp;|&quot;|&lt;|&gt;/g, ' ') // Замінюємо HTML-ентіті на пробіли
      .replace(/\s+/g, ' ') // Замінюємо множинні пробіли на один
      .trim(); // Видаляємо зайві пробіли на початку та в кінці
    const firstSentence = textContent.split('.')[0];
    return firstSentence.length > 0 ? firstSentence : ``;
    // "Опис публікації";
};

export function formatShortName(name) {
  return name.replace(/<\/?h1[^>]*>/g, '');
}